import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/service/auth.service";
import { LeaderboardDTO } from "src/app/data/schema/Gamification/Leaderboard/LeaderboardDTO";
import enUS from "./i18n/en-US.json";
import esES from "./i18n/es-ES.json";
import ptBR from "./i18n/pt-BR.json";

@Component({
    selector: "app-leaderboard-list",
    templateUrl: "./leaderboard-list.component.html",
    styleUrls: ["./leaderboard-list.component.scss"]
})
export class LeaderboardListComponent implements OnInit {
    @Input() leaderboards: LeaderboardDTO[];
    loggedUserId: string;
    loggedUserGroupIds: string[];

    constructor(private _translateService: TranslateService, private authService: AuthService) {
        this._translateService.setTranslation("pt-BR", ptBR, true);
        this._translateService.setTranslation("en-US", enUS, true);
        this._translateService.setTranslation("es-ES", esES, true);
    }

    ngOnInit(): void {
        this.loggedUserId = this.authService.getClaimsUserId();
        this.loggedUserGroupIds = this.authService.getClaimsGroupIds();
    }

    tooltipDesc(leader: LeaderboardDTO): string {
        return leader.userId ? `${leader.userSummary.name} ${leader.userSummary.surname}` : leader.groupSummary?.name;
    }

    userIsInTheGroup(id: string): boolean {
        if (!id) return false;
        return this.loggedUserGroupIds?.includes(id);
    }
}
